import { SvgIcon, SvgIconProps } from '@mui/material';

export const Route = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx="6" cy="19" r="3" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="18" cy="5" r="3" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
